import { useState } from "react";
import BusinessForm from "./BusinessForm";
import Collapse from "./Collapse";
import ColorPicker from "./ColorPicker";
import CoverPicker from "./CoverPicker";
import Dialog from "./Dialog";
import Icon from "./Icon";
import OrdersCard from "./OrdersCard";
import OrdersList from "./OrdersList";
import MercadoPagoCard from "./MercadoPagoCard";
import PromosCard from "./PromosCard";
import { PROMOS_PRO_ONLY } from "../../plans.js";
import { promosAvailable, promosOf } from "../../promos.js";
import ReviewsCard from "./ReviewsCard";

// En el celular las dos mitades se ven de a una, con pestañas arriba.
const PANES = [
    { id: "pedidos", label: "Pedidos" },
    { id: "datos", label: "Datos del negocio" }
];

const BusinessPanel = ({ data }) => {

    const { business, products } = data;
    const [editing, setEditing] = useState(false);
    const [pane, setPane] = useState("pedidos");
    const [open, setOpen] = useState({ datos: false, colores: false, portada: false, promos: false });

    const toggle = (key) => setOpen((o) => ({ ...o, [key]: !o[key] }));

    const rows = [
        ["Nombre", business.nombreEmpresa],
        ["Descripción", business.descripcionEmpresa],
        ["Dirección", [business.calle, business.altura].filter(Boolean).join(" ") + (business.ciudad ? `, ${business.ciudad}` : "") + (business.provincia ? `, ${business.provincia}` : "")],
        ["WhatsApp", /^[0-9]+$/.test(business.telefono || "") ? "+" + business.telefono : business.telefono],
        ["Horarios", [business.horario, business.horarioSec].filter(Boolean).join(" · ")]
    ];
    const missing = rows.some(([, value]) => !value);

  return (
    <div className="lp-panel-page">
        <div className="lp-panel-head">
            <div>
                <h1>Mi negocio</h1>
                <p className="lp-panel-muted">Los pedidos que te llegan y los datos, la portada y los colores que ven tus clientes en el menú.</p>
            </div>
        </div>

        <div className="lp-panel-tabs" role="tablist" aria-label="Secciones de Mi negocio">
            {PANES.map((p) => (
                <button key={p.id} type="button" role="tab" id={"tab-" + p.id} aria-controls={"pane-" + p.id} aria-selected={pane === p.id} onClick={() => setPane(p.id)}>{p.label}</button>
            ))}
        </div>

        <div className="lp-panel-grid">
            <div id="pane-pedidos" role="tabpanel" aria-labelledby="tab-pedidos" className={pane === "pedidos" ? "lp-panel-col lp-panel-stack" : "lp-panel-col lp-panel-stack lp-panel-pane-off"}>
                <OrdersList business={business} onGoToSettings={() => setPane("datos")}></OrdersList>
            </div>

            <div id="pane-datos" role="tabpanel" aria-labelledby="tab-datos" className={pane === "datos" ? "lp-panel-col lp-panel-stack" : "lp-panel-col lp-panel-stack lp-panel-pane-off"}>
                <Collapse
                    title="Datos del negocio"
                    open={open.datos}
                    onToggle={() => toggle("datos")}
                    before={business.logo && <img className="lp-panel-collapse-logo" src={business.logo} alt=""/>}
                    after={missing && <span className="lp-panel-badge">Falta completar</span>}
                >
                    <dl className="lp-panel-rows">
                        {rows.map(([label, value]) => (
                            <div key={label}>
                                <dt>{label}</dt>
                                <dd>{value || <span className="lp-panel-missing">Falta completar</span>}</dd>
                            </div>
                        ))}
                    </dl>
                    <button type="button" className="lp-btn lp-btn-secondary lp-panel-btn-sm lp-panel-left" onClick={() => setEditing(true)}>
                        <Icon name="edit" size={18}></Icon> Editar datos
                    </button>
                </Collapse>

                <OrdersCard business={business} onChange={data.setOrders} onDeliveryCost={data.setDeliveryCost} onEditData={() => setEditing(true)}></OrdersCard>

                <MercadoPagoCard business={business} onChanged={data.reload}></MercadoPagoCard>

                <ReviewsCard business={business} onSave={data.saveReviews} onEditData={() => setEditing(true)}></ReviewsCard>

                <Collapse title="Portada del menú" open={open.portada} onToggle={() => toggle("portada")} after={business.subscribed !== true && <span className="lp-panel-badge">Pro</span>}>
                    <CoverPicker business={business} onSave={data.saveCover} onRemove={data.removeCover}></CoverPicker>
                </Collapse>

                <Collapse title="Promociones" open={open.promos} onToggle={() => toggle("promos")}
                    after={promosAvailable(business, PROMOS_PRO_ONLY)
                        ? promosOf(business).length > 0 && <span className="lp-panel-count">{promosOf(business).length}</span>
                        : <span className="lp-panel-badge">Pro</span>}>
                    <PromosCard data={data}></PromosCard>
                </Collapse>

                <Collapse title="Colores de tu menú" open={open.colores} onToggle={() => toggle("colores")}>
                    <ColorPicker business={business} products={products} onSave={data.saveColors}></ColorPicker>
                </Collapse>
            </div>
        </div>

        <Dialog open={editing} title="Datos del negocio" onClose={() => setEditing(false)} wide>
            <BusinessForm business={business} onCancel={() => setEditing(false)} onSubmit={async (fields, logo) => {
                if (await data.saveBusiness(fields, logo)) setEditing(false);
            }}></BusinessForm>
        </Dialog>
    </div>
  )
}

export default BusinessPanel
